import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'sessions', pathMatch: 'full' },
  {
    path: 'sessions',
    loadComponent: () =>
      import('./features/sessions-list/pages/sessions-list.page').then(m => m.SessionsListPage),
    canActivate: [authGuard],
  },
  {
    path: 'new',
    loadComponent: () =>
      import('./features/session/pages/new-session.page').then(m => m.NewSessionPage),
    canActivate: [authGuard],
  },
  {
    path: 'session/:sessionId',
    loadComponent: () =>
      import('./features/session/pages/active-session.page').then(m => m.ActiveSessionPage),
    canActivate: [authGuard],
  },
  {
    path: 'library',
    loadComponent: () =>
      import('./features/library/pages/library.page').then(m => m.LibraryPage),
    canActivate: [authGuard],
  },
];
